import React, { useState } from "react";
import { Button } from "carbon-components-react";
import { DocumentDownload16 } from "@carbon/icons-react";

import exportToCsv from "@eave/shared/utils/exportToCSV";
import APIClient from "web_modules/APIClient";

type Incidents = {
  incident_number: number;
  title: string;
  description: string;
  html_url: string;
  created_at: string; // triggered time, not db created_at
};

const getPagerDutyIncidents = async (): Promise<Incidents[]> => {
  const { incidents } = (await APIClient.get("/uw/pager_duty/incidents")) as {
    incidents: Incidents[];
  };
  return incidents;
};

const DownloadIncidentsButton = () => {
  const [isFetching, setIsFetching] = useState(false);

  const onClickHandler = async () => {
    setIsFetching(true);

    const incidents = await getPagerDutyIncidents();
    const rows = incidents.map(({ incident_number, title, description, created_at, html_url }) => [
      incident_number,
      title,
      description,
      created_at,
      html_url,
    ]);
    const csvHeader = ["Incident number", "title", "description", "created at", "html url"];

    exportToCsv(csvHeader, rows, "pager_duty_incidents.csv");
    setIsFetching(false);
  };

  return (
    <Button disabled={isFetching} onClick={onClickHandler} renderIcon={DocumentDownload16}>
      Download CSV
    </Button>
  );
};

export default DownloadIncidentsButton;
